var site = site || {};

(function ($) {
  Drupal.behaviors.productFullV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var self = this;
      var $fullProduct = $('.js-product-full-v1', context);
      var $fullProductCarousel = $('.js-spp-carousel.slick-initialized', context);
      var $sppThumbnails = $('.js-product-full-image-thumbs-content-inner.slick-initialized', context);

      self.attached = true;
      
      $fullProduct.each(function () {
        var $container = $(this);
        var $slickCount = $('.js-slick-count', $container);
        self.initMainImageCarousel($container);

        $fullProductCarousel.on('afterChange', function(event, slick, currentSlide){
          $slickCount.text(currentSlide + 1 + '/' + slick.slideCount);
          $sppThumbnails.slick('slickGoTo', currentSlide);
          $sppThumbnails.find('.active').removeClass('active');
          $sppThumbnails.find('.product-full__image-thumb[data-slick-index=' + currentSlide + ']').addClass('active');
        });

        $(window).on(
          'resize',
          _.debounce(function () {
            self.initMainImageCarousel($container);
          }, 100)
        );

        $('.js-spp-carousel__slide', $container)
          .once()
          .click(function (e) {
            e.preventDefault();
            if (self.checkIsDesktop()) {
              self.initFullScreen($container);
            }
          })
          .on('keydown.fullImage', function (e) {
            var key = site.getKeycode(e);

            if (key === 13) {
              // Enter
              e.preventDefault();
              self.initFullScreen($container);
            }
          });
      });
    },
    initFullScreen: function ($container) {
      var self = this;
      var $fullscreenClose = $('.js-product-full__image-close', $container);

      // Expand the image container
      $container.addClass('fullscreen-enabled');
      $('body').addClass('fullscreen-enabled');

      $fullscreenClose.off('click').on('click', function (e) {
        e.preventDefault();
        self.closeFullScreen($container);
      });

      // Key Bindings
      $(window).on('keydown.fullImage', function (e) {
        var key = site.getKeycode(e);

        if (open && key === 27) {
          // Esc
          e.preventDefault();
          self.closeFullScreen($container);
        }
      });

      self.initMainImageCarousel($container);
    },
    closeFullScreen: function ($container) {
      var self = this;
      $container.removeClass('fullscreen-enabled');
      $('body').removeClass('fullscreen-enabled');
      $(window).off('keydown.fullImage');
      self.initMainImageCarousel($container);
    },
    checkIsDesktop: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlandscapeUp = parseInt(Unison.fetch.all()['landscape'], 10);
      var isDesktop = currentBpWidth >= bPlandscapeUp;
      return isDesktop;
    },
    initMainImageCarousel: function ($container) {
      var self = this;
      if (self.checkIsDesktop()) {
        // Refresh the main image carousel
        $('.js-spp-carousel.slick-initialized', $container).slick('refresh');

        return;
      }
    },
    attached: false
  };
})(jQuery);
